import React from 'react';
import { Button } from '@abb/abb-common-ux-react';
import * as CONSTANTS from "../../utilities/Constants";
import { useTranslation } from 'react-i18next';

interface KeyCloakStatusProps {
    checkIsKeyCloakStatus: () => void;
}

const KeyCloakStatus: React.FC<KeyCloakStatusProps> = ({ checkIsKeyCloakStatus }) => {
    const { t } = useTranslation();

    return (
        <div>
            {t(CONSTANTS.SERVICES)} {'>'} {t(CONSTANTS.LMSIDENTITYSERVICE)} {'>'} {t(CONSTANTS.START)} <br />
            <Button
                text="Re-Check Authentication Server Status"
                type="primary-black"
                onClick={checkIsKeyCloakStatus}
                shape="rounded"
            />
        </div>
    );
};

export default KeyCloakStatus;